import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const CookIslands: Country = {
    identifier: "CookIslands",
    name: "Cook Islands",
    countryCode: "CK",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇨🇰",
    svgPath: "m 26.585748,523.5834 -0.09,10e-4 -0.114,-0.022 -0.074,-0.012 -0.008,-0.028 0.029,-0.085 0.06,-0.042 0.119,0.006 0.081,0.059 0.007,0.097 z",
}
